import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InterestComponent = _resolveComponent("InterestComponent")!
  const _component_el_space = _resolveComponent("el-space")!

  return (_openBlock(), _createBlock(_component_el_space, {
    size: 8,
    fill: "",
    "w-100": "",
    class: "App-Interests-List"
  }, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.interests, (opp, index) => {
        return (_openBlock(), _createBlock(_component_InterestComponent, {
          Interest: opp,
          key: `opp-${index}`
        }, null, 8, ["Interest"]))
      }), 128))
    ]),
    _: 1
  }))
}